import { render, staticRenderFns } from "./service-plans-table.vue?vue&type=template&id=34e97474"
import script from "./service-plans-table.vue?vue&type=script&lang=js"
export * from "./service-plans-table.vue?vue&type=script&lang=js"
import style0 from "./service-plans-table.vue?vue&type=style&index=0&id=34e97474&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports